import React from "react";
import { dateRange } from "./templateHelpers";
import ExtraResumeSections from "./ExtraResumeSections";

export default function NewspaperTemplate({ draft, accent }) {
  return (
    <div className="bg-white text-slate-900 rounded-xl p-8 shadow-2xl text-[13px] leading-snug font-serif" data-testid="resume-live-preview">
      <div className="text-center">
        <h1 className="text-4xl font-black tracking-tight" style={{ color: accent }}>{draft.full_name || "Your Name"}</h1>
        <p className="text-slate-500 text-[11px] mt-1 uppercase tracking-widest">{[draft.target_role, draft.location].filter(Boolean).join(" — ")}</p>
      </div>
      <div className="border-t-4 border-double mt-2" style={{ borderColor: accent }} />
      <p className="text-slate-400 text-[10px] text-center mt-1">{[draft.contact_email, draft.contact_phone].filter(Boolean).join("  ·  ")}</p>

      {draft.summary && <p className="text-slate-700 mt-4 text-center italic px-4">{draft.summary}</p>}

      <div className="grid grid-cols-2 gap-6 mt-5">
        <div className="border-r pr-5" style={{ borderColor: "#e2e8f0" }}>
          {draft.experience.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1 mb-2" style={{ color: accent, borderColor: `${accent}40` }}>Experience</h2>
              {draft.experience.map((e, i) => (
                <div key={i} className="mb-2.5">
                  <p className="font-bold text-slate-800">{e.title}, {e.company}</p>
                  <p className="text-slate-400 text-[11px] italic">{dateRange(e.start_date, e.end_date, e.current)}</p>
                  <ul className="list-disc list-inside text-slate-700 mt-0.5">{e.bullets.filter(Boolean).map((b, bi) => <li key={bi}>{b}</li>)}</ul>
                </div>
              ))}
            </div>
          )}
        </div>
        <div>
          {draft.education.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1 mb-2" style={{ color: accent, borderColor: `${accent}40` }}>Education</h2>
              {draft.education.map((ed, i) => <p key={i} className="text-slate-700 mb-1"><span className="font-semibold">{ed.degree} {ed.field}</span> — {ed.school}</p>)}
            </div>
          )}
          {draft.skills.length > 0 && (
            <div className="mb-4">
              <h2 className="text-xs font-bold uppercase tracking-wider border-b pb-1 mb-2" style={{ color: accent, borderColor: `${accent}40` }}>Skills</h2>
              <p className="text-slate-700">{draft.skills.join(", ")}</p>
            </div>
          )}
        </div>
      </div>
      <ExtraResumeSections draft={draft} accent={accent} />
    </div>
  );
}
